import React, { Component } from 'react';
import { UncontrolledTooltip } from 'reactstrap';

import './ScoreBar.scss';

const getColour = (score) => {
  if (score < 33) {
    return '#d9534f';
  } else if (score < 66) {
    return '#f0ad4e';
  } else {
    return '#5cb85c';
  }
};

const averageScore = (scores) => {
  if (scores.length === 0) return 'N/A';
  return Math.round((scores.reduce((acc, cur) => {
    return acc + parseFloat(cur.skill_score);
  }, 0) / scores.length) * 100) / 100;
};

class ScoreBar extends Component {
  render () {
    console.log(this.props.entry);
    return (
      <div className='student-report-score-list-scorebar' key={this.props.entry.id}>
        <p>
          <span>{this.props.entry.skill_name}</span>
          {this.props.entry.skill_description && (
            <span>
              &nbsp;
              <i className='fa fa-info-circle' id={`infobox-${this.props.entry.id}`} aria-hidden='true' />
              <UncontrolledTooltip target={`infobox-${this.props.entry.id}`}>{this.props.entry.skill_description}</UncontrolledTooltip>
            </span>
          )}
        </p>
        <div className='progress'>
          <div className='progress-bar' role='progressbar'
            style={{ 'width': `${averageScore(this.props.entry.skill_scores)}%`, background: getColour(averageScore(this.props.entry.skill_scores)) }} />
        </div>
      </div>
    );
  }
}

export default ScoreBar;



// WEBPACK FOOTER //
// ./src/routes/student-report/routes/StudentReport/components/StudentReport/components/ScoreList/components/ScoreBar/index.js